import AWS, { Config } from 'aws-sdk';
import {
  CognitoUserPool,
  AuthenticationDetails,
  CognitoUser
} from 'amazon-cognito-identity-js';

function completeReg(userInfo, config) {
  const userPool = new CognitoUserPool({
    UserPoolId: config.UserPoolId,
    ClientId: config.ClientId,
  });

  // console.log(userInfo);
  const userData = {
    Username: userInfo.username,
    Pool: userPool
  };

  const authenticationData = {
    Username: userInfo.username,
    Password: userInfo.password,
  };

  Config.region = config.region;

  const cognitoUser = new CognitoUser(userData);
  const authenticationDetails = new AuthenticationDetails(authenticationData);

  const prom = new Promise((resolve, reject) => {
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess(result) {
        resolve(result);
      },
      mfaSetup: (challengeName, challengeParameters) => {
        const error = {
          code: 'MFA_CHALLENGE',
          message: 'MFA is not implemented'
        };
        reject(error);
      },
      associateSecretCode: (secretCode) => {
        console.log('associate secret code');
      },
      selectMFAType: (challengeName, challengeParameters) => {
        console.log('select mfa code');
      },
      totpRequired: (secretCode) => {
        console.log('Please input the TOTP code.');
      },
      newPasswordRequired: (userAttributes, requiredAttributes) => {
        // TODO: add redirect to change pwd screen, remove hard coded values
        console.log('completing user reg');
        const attributes = {
          given_name: userInfo.given_name,
          family_name: userInfo.family_name,
          'custom:suffix': userInfo.suffix
        };

        cognitoUser.completeNewPasswordChallenge(userInfo.password, attributes, {
          onSuccess: (user) => {
            resolve(user);
          },
          onFailure: (error) => {
            reject(error);
          },
        });
      },
      onFailure(err) {
        reject(err);
      }
    });
  });

  return prom;
}

export default function completeRegistration(userInfo, config) {
  return dispatch => dispatch({
    type: 'COMPLETE_REGISTRATION_FETCH',
    payload: completeReg(userInfo, config)
  });
}



// WEBPACK FOOTER //
// ./src/actions/completeRegistration.js